import { Space } from 'antd'
import React, { useState } from 'react'
import Button from '../../../components/Button'
import Flex from '../../../components/Flex'
import ActionRoleDrawer from '../../../components/UIElements/ActionRoleDrawer'
import SuccessModal from '../../../components/UIElements/ActionRoleDrawer/SuccessModal'
import SuccessIcon from '../../../components/icons/SuccessIcon'
import { OPT_OUT_CONFIG } from '../../../utils/constants'
import { AntdText } from '../../ManageProfile/Style/style'
import { ToggleCard } from './style'

const OptoutNotification = ({
  studentData,
  updateOptedWitdrawStatus,
  isOptOut,
  studentOptedStatus,
}) => {
  const [successModal, setSuccessModal] = useState(false)
  const [confirmationModal, setConfirmationModal] = useState(false)
  const handleWithdraw = () => {
    setConfirmationModal(true)
  }
  const handleSuccess = () => {
    setSuccessModal(false)
    studentOptedStatus()
  }
  const handleConfirm = () => {
    setSuccessModal(true)
    setConfirmationModal(false)
    updateOptedWitdrawStatus({
      isOptOut: false,
    })
  }
  const handleClose = () => {
    setConfirmationModal(false)
  }
  console.log(isOptOut, 'iSoptOut')
  return (
    <>
      <Space direction="vertical" size={16}>
        <ToggleCard>
          <Flex>
            <AntdText fs={12} strong>
              {OPT_OUT_CONFIG?.OptedOutPending?.message}
            </AntdText>
            <Button.Primary text="Withdraw" onClick={handleWithdraw} />
          </Flex>
        </ToggleCard>
      </Space>
      <SuccessModal
        showDrawer={successModal}
        setShowDrawer={setSuccessModal}
        description={OPT_OUT_CONFIG?.OptedOutPending?.statusMessage}
        Icon={SuccessIcon}
        handleCloseDrawer={handleSuccess}
      />
      <ActionRoleDrawer
        showDrawer={confirmationModal}
        setShowDrawer={setConfirmationModal}
        description={`Are you sure you want to withdraw your ${'opt-out'}?`}
        handleCloseDrawer={handleConfirm}
        onCloseClick={handleClose}
      />
    </>
  )
}

export default OptoutNotification
